/* eslint-disable no-useless-computed-key */
import DownloadIcon from '@mui/icons-material/Download';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Card from '../../../components/layout/Card';
import { Flex, Grid, MarginHandler } from '../../../styledComponents';
import ButtonCom from '../../../components/button/ButtonCom';
import TransitionsModal from '../../../components/modal/Modal';
import InputControl from '../../../components/input/InputControl';
import { FormControlLabel, Checkbox, FormGroup, FormControl, FormLabel, IconButton, Tooltip, Box, Typography, Button, InputLabel, MenuItem, LinearProgress, CircularProgress, Chip, Switch, TextField, Collapse } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import FilterListIcon from '@mui/icons-material/FilterList';
import ClearIcon from '@mui/icons-material/Clear';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { colors, fonts } from '../../../utils';
import { endPoints } from '../../../api/apiEndpoints';
import { Api } from '../../../api/api';
// import { setAllPostCategories } from '../../../redux/slices/posts/posts';
import { setAllDocuments } from '../../../redux/slices/shareholderRights/shareholderRights';
import { errorNotify, successNotify } from '../../../utils/helper';
import Table from '../../../components/table/Table';
import EditIcon from '@mui/icons-material/Edit';
import ImageIcon from '@mui/icons-material/Image';
import DeleteIcon from '@mui/icons-material/Delete';
import AddBoxIcon from '@mui/icons-material/AddBox';
import { useNavigate } from 'react-router-dom';
import DeleteModal from '../../../components/deletemodal/DeleteModal';
import moment from 'moment';
import { setAllCoursesCategories } from '../../../redux/slices/shareholderEducation/shareholderEducation';
import Editor from 'react-simple-wysiwyg';
import FilledSelectOption from '../../../components/input/FilledSelectOption';


const CourseCategories = () => {
	const dispatch = useDispatch();
	const { clientId, userId, fullName } = useSelector((state) => state?.activeAccount);
	const { primaryFont } = fonts;

	const { colorWhite, colorPrimary, colorGreenGradient } = colors;

	const { coursesCategories } = useSelector((state) => state.shareHolderEducation);

	const [openModal, setOpenModal] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [openDeleteModal, setOpenDeleteModal] = useState(false);
	const [isEditing, setIsEditing] = useState(false);
	const [isLoadingImg, setIsLoadingImg] = useState(false);

	const [formData, setFormData] = useState({
		name: '',
		description: '',
	});
	const [currentParams, setCurrentParams] = useState({
		limit: 10,
		page: 1,
		totalPages: 0,
		totalRecords: 0,
	});
	const [filters, setFilters] = useState({
		search: '',
		status: '',
		date_from: null,
		date_to: null,
	});
	const [filtersOpen, setFiltersOpen] = useState(false);

	const handleFilterChange = (e) => {
		setFilters((prevState) => ({
			...prevState,
			[e.target.name]: e.target.value,
		}));
	};

	const handleFilterDateChange = (name, value) => {
		setFilters((prevState) => ({
			...prevState,
			[name]: value,
		}));
	};

	const handleApplyFilters = () => {
		getData(currentParams.limit, 1, filters);
	};

	const handleClearFilters = () => {
		const clearedFilters = {
			search: '',
			status: '',
			date_from: null,
			date_to: null,
		};
		setFilters(clearedFilters);
		getData(currentParams.limit, 1, clearedFilters);
	};

	const handleCloseModal = () => {
		setOpenModal(false);
		setIsEditing(false);
	};

	const handleChange = (e) => {
		setFormData((prevState) => ({
			...prevState,
			[e.target.name]: e.target.value,
		}));
	};

	const getData = async (limit, page, filterParams = filters) => {
		setIsLoading(true)
		try {

			await Api.post(endPoints?.courseCategory?.fetch,
				{
					"limit": limit || 10,
					"page": page || 1,
					"search": filterParams.search || null,
					"status": filterParams.status || null,
					"date_from": filterParams.date_from ? dayjs(filterParams.date_from).format('YYYY-MM-DD') : null,
					"date_to": filterParams.date_to ? dayjs(filterParams.date_to).format('YYYY-MM-DD') : null,
				}, {
				headers: {
					'xt-user-token': null
				}
			})
				.then((response) => {
					dispatch(
						setAllCoursesCategories(
							response?.data?.data?.categories?.categories?.map((d, index) => ({
								index: index + 1,
								id: d?.id,
								name: d?.name,
								description: d?.description,
								dt: d?.dt,
								status: d?.status,
							})
							),
						),
					);
					const { page, limit, totalPages, totalRecords } = response?.data?.data?.categories?.pagination;
					setCurrentParams({ page, limit, totalPages, totalRecords });
					setIsLoading(false)

				})
				.catch((error) => {
					// if (error?.response?.status === 400) {
					// 	errorNotify(error?.response?.data);
					// 	setDisabledBtn(false);
					// }
					// setErrMsg(error?.response?.data?.message || errorMsg);
				});
		} catch (err) {
			// setErrMsg('Login Failed');
			// setDisabledBtn(false);
		}
	};

	const handleCreateModal = () => {
		setFormData({ name: '', description: '' })
		setOpenModal(true)
		setIsEditing(false);
	};
	const handleEditModal = (val) => {
		const { name, id, description, status } = val;

		setFormData({
			name,
			id,
			description,
			status
		});
		setOpenModal(true)
		setIsEditing(true);
	};


	const handleSubmit = async () => {
		if (!isEditing) {


			try {

				await Api.post(endPoints?.courseCategory?.create, {
					...formData,
					// creator_id: userId,
					// creator_name: fullName,
				}, {
					headers: {
						'xt-user-token': null
					}
				})
					.then((response) => {
						handleCloseModal();
						getData();
						successNotify("Category Created Successfully")

					})
					.catch((error) => {

					});

			} catch (err) {
			}

		} else {


			try {

				await Api.post(endPoints?.courseCategory?.update, {
					...formData,
					// creator_id: userId,
					// creator_name: fullName,
				}, {
					headers: {
						'xt-user-token': null
					}
				})
					.then((response) => {
						handleCloseModal();
						getData();
						successNotify("Category Updated Successfully")

					})
					.catch((error) => {

					});

			} catch (err) {
			}
		}
	};

	useEffect(() => {
		getData();
	}, [])


	const handleSwitchClick = (event) => {
		event.stopPropagation();
	};

	const handleChangeTableSwitch = async (event, val) => {

		try {

			await Api.post(endPoints?.courseCategory?.delete, {
				id: val.id,
				status: event.target.checked,
			}, {
				headers: {
					'xt-user-token': null
				}
			})
				.then((response) => {
					successNotify("Course Category Status Updated Successfully")
					getData();

				})
				.catch((error) => {

				});

		} catch (err) {
		}

	};

	const column = [
		{
			title: 'Id',
			field: 'id',
			render: (rowData) => <h4 className='font-face-R'>{rowData?.id}</h4>,
		},
		// {
		// 	title: 'Category Id',
		// 	field: 'category_id',
		// 	render: (rowData) => <h4 className='font-face-B'>{rowData?.category_id}</h4>,
		// },
		{
			title: 'Name',
			field: 'name',
			render: (rowData) => <h4 className='font-face-R'>{rowData?.name}</h4>,
		},
		{
			title: 'Description',
			field: 'description',
			width: "10%",
			render: (rowData) => <h4 className='font-face-R'>{rowData?.description}</h4>,
		},
		{
			title: 'Date',
			field: 'dt',
			render: (rowData) => <h4 className='font-face-R'>{moment(rowData?.dt).format("DD-MM-YYYY")}</h4>,
		},
		{
			title: 'Edit',
			field: 'edit',
			filtering: false,
			render: (rowData) => (
				<Tooltip title='Edit'>
					<IconButton onClick={() => handleEditModal(rowData)} aria-label='Edit'>
						<EditIcon />
					</IconButton>
				</Tooltip>
			),
		},
		{
			title: 'Status',
			field: 'status',
			render: (rowData) =>
				<Switch onClick={handleSwitchClick} onChange={(event) => handleChangeTableSwitch(event, rowData)} checked={rowData?.status} name='enabled' />,
		},

	];


	return (
		<>

			<Card margin='3rem 1.5rem' padding='3rem'>

				<Flex jc='flex-end' gap='1rem' mb='2rem' fw='wrap'>
					<ButtonCom onClickHandler={handleCreateModal} btnTitle={"Create"} />
				</Flex>

				{/* Filters Section */}
				<Box sx={{ mb: 3, backgroundColor: '#f5f5f5', borderRadius: '8px', overflow: 'hidden' }}>
					<Box
						sx={{
							p: 2,
							cursor: 'pointer',
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center',
							'&:hover': { backgroundColor: '#ebebeb' },
							transition: 'background-color 0.2s ease'
						}}
						onClick={() => setFiltersOpen(!filtersOpen)}
					>
						<Flex ai='center' gap='0.5rem'>
							<FilterListIcon sx={{ color: '#666' }} />
							<Typography variant='h6' sx={{ fontSize: '1.6rem', fontWeight: 600, color: '#333' }}>
								Filter Categories
							</Typography>
						</Flex>
						{filtersOpen ? <ExpandLessIcon sx={{ color: '#666' }} /> : <ExpandMoreIcon sx={{ color: '#666' }} />}
					</Box>

					<Collapse in={filtersOpen} timeout={300}>
						<Box sx={{ p: 2, pt: 1 }}>
							{/* Search Bar */}
							<Box sx={{ mb: 2 }}>
								<InputControl
									state={filters.search}
									onChange={handleFilterChange}
									label='Search by Name'
									name='search'
								/>
							</Box>

							{/* Dropdown Filters */}
							<Grid gtc='repeat(auto-fit, minmax(18rem, 1fr))' gap='1.5rem'>
								<FilledSelectOption
									label='Status'
									state={filters.status}
									onChange={handleFilterChange}
									options={[
										{ id: 'true', description: 'Active' },
										{ id: 'false', description: 'Inactive' },
									]}
									maxWidth='100%'
									minWidth='100%'
									width='100%'
									name='status'
								/>
								<LocalizationProvider dateAdapter={AdapterDayjs}>
									<DesktopDatePicker
										label='Date From'
										value={filters.date_from}
										onChange={(value) => handleFilterDateChange('date_from', value)}
										renderInput={(params) => <TextField {...params} size='small' />}
									/>
								</LocalizationProvider>
								<LocalizationProvider dateAdapter={AdapterDayjs}>
									<DesktopDatePicker
										label='Date To'
										value={filters.date_to}
										onChange={(value) => handleFilterDateChange('date_to', value)}
										renderInput={(params) => <TextField {...params} size='small' />}
									/>
								</LocalizationProvider>
							</Grid>

							<Flex jc='space-between' ai='center' gap='1rem' mt='1.5rem'>
								<Button
									variant='text'
									startIcon={<ClearIcon />}
									onClick={handleClearFilters}
									sx={{ fontSize: '1.2rem', textTransform: 'none', color: '#666' }}>
									Clear All
								</Button>
								<Button
									variant='contained'
									color='success'
									startIcon={<SearchIcon />}
									onClick={handleApplyFilters}
									sx={{ fontSize: '1.2rem', textTransform: 'none', px: 3 }}>
									Apply Filters
								</Button>
							</Flex>
						</Box>
					</Collapse>
				</Box>

				<Flex jc='flex-end' gap='1rem' mb='2rem' fw='wrap'>

					<TransitionsModal
						open={openModal}
						// handleOpen={handleOpenModal}
						handleClose={handleCloseModal}
						modalTitle={isEditing ? "Edit Course Category" : "Create Course Category"}
					>

						<Grid gtc='repeat(auto-fit, minmax(40rem, 1fr))' padding='2rem'>
							<MarginHandler width='100%'>
								<InputControl
									state={formData?.name}
									onChange={handleChange}
									// inputProps={{ maxLength: 60 }}
									label='Name'
									name='name'
								/>
							</MarginHandler>
							<MarginHandler width='100%'>
								<InputControl
									state={formData?.description}
									onChange={handleChange}
									// inputProps={{ maxLength: 120 }}
									label='Description'
									name='description'
								/>
							</MarginHandler>


							<MarginHandler mt="2rem">
								<Button
									color='primary'
									variant='contained'
									onClick={handleSubmit}
									style={{
										// backgroundColor: colorPrimary,
										background: colorGreenGradient,
										fontSize: '1.6rem',
										textTransform: 'none',
										padding: '0.7rem 2rem',
										color: colorWhite,
										borderRadius: '0.5rem',
										float: "right"
									}}
									disabled={!formData.name}
									className='font-face-R'>
									{isEditing ? "Update " : "Create "}
								</Button>
							</MarginHandler>

						</Grid>
					</TransitionsModal>
				</Flex>






				{/* <DeleteModal
					open={openDeleteModal}
					handleClose={handleCloseDeleteModal}
					handleDelete={handleDelete}
				/> */}


				{isLoading ?
					<Box sx={{ m: '5rem' }}>
						<LinearProgress color="success" />
					</Box>
					:
					<Table
						columns={column}
						tableData={coursesCategories?.map((item) => ({ ...item }))}
						sorting
						columnsButton
						padding="3rem"
						showTitle
						paginationType='normal'
						titleHeading="Courses Categories"
						showToolbar={true}
						pageSize={currentParams.limit}
						onChangeRowsPerPage={(event) => getData(parseInt(event.target.value, 10), 1)}
						totalRecords={currentParams.totalRecords}
						handlePageChange={(event, newPage) => getData(currentParams.limit, newPage + 1)}
						curPage={currentParams.page - 1}
					/>
				}








			</Card>
		</>
	);
};

export default CourseCategories;
